import Nullstack from 'nullstack'
import './VideoSales.css'
export default function VideoSales() {

  return (
    <>
   
    <div class="flex justify-center mt-20 w-full">
        <div class="embed-full">
            <iframe src="https://www.youtube.com/embed/jkx2ogSBmT8?si=1I7XdWlQhNgPfVzC" />
        </div>
    </div>
   
    </>
  );
}
